if (!customElements.get('dragenz-opening-choice')) {
  customElements.define('dragenz-opening-choice', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.form = document.getElementById(this.dataset.formId);
      if (!this.form) return;
      this.initialized = true;
      const url = new URL(window.location.href);
      this.preservedParams = new URLSearchParams(url.search);
      ['variant', 'opening', 'option_values', 'section_id'].forEach((key) => this.preservedParams.delete(key));
      this.isProductPage = url.pathname.endsWith(new URL(this.dataset.productUrl, url.origin).pathname);
      const requestedOpening = this.isProductPage ? url.searchParams.get('opening') : null;
      if (this.isProductPage && this.dataset.legacyVariant === 'true' && this.dataset.standardVariantId) {
        url.searchParams.set('variant', this.dataset.standardVariantId);
        const opening = requestedOpening === 'Livestream' || requestedOpening === 'Sealed'
          ? requestedOpening
          : 'Livestream';
        url.searchParams.set('opening', opening);
        window.location.replace(url.toString());
        return;
      }
      const explicitStandardVariant = this.isProductPage
        && url.searchParams.get('variant') === this.dataset.standardVariantId;
      const choice = requestedOpening === 'Livestream' || requestedOpening === 'Sealed'
        ? requestedOpening
        : explicitStandardVariant ? 'Sealed' : 'Livestream';
      this.querySelectorAll('input[type="radio"]').forEach((input) => { input.checked = input.value === choice; });
      this.onChoiceChange = () => this.updateOpeningUrl();
      this.onVariantChange = (event) => {
        if (event.target.name === 'id') this.updateOpeningUrl();
      };
      this.addEventListener('change', this.onChoiceChange);
      this.form.addEventListener('change', this.onVariantChange);
    }

    updateOpeningUrl() {
      if (!this.isProductPage) return;
      const checked = this.querySelector('input[type="radio"]:checked');
      if (!checked) return;
      const url = new URL(window.location.href);
      this.preservedParams.forEach((value, key) => {
        if (!url.searchParams.has(key)) url.searchParams.append(key, value);
      });
      url.searchParams.set('opening', checked.value);
      window.history.replaceState(window.history.state, '', url.toString());
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChoiceChange);
      this.form?.removeEventListener('change', this.onVariantChange);
      this.initialized = false;
    }
  });
}
